import React from 'react';
import { MultiSelect } from '@roger/ui-components';
import { Question } from '../types';

interface MultiSelectQuestionProps {
  question: Question;
  value: string[];
  onChange: (value: string[]) => void;
}

export const MultiSelectQuestion: React.FC<MultiSelectQuestionProps> = ({
  question,
  value = [],
  onChange,
}) => {
  if (!question.values) {
    return (
      <div className='text-red-600'>MultiSelect question missing values</div>
    );
  }

  const options = question.values.map(val => ({
    value: val,
    label: val,
  }));

  return (
    <div className='space-y-3'>
      <label className='text-sm font-medium text-gray-900 block'>
        {question.description}
        {question.qid && (
          <span className='ml-2 text-xs text-gray-500'>({question.qid})</span>
        )}
      </label>

      <MultiSelect
        options={options}
        value={value}
        onChange={onChange}
        orientation='vertical'
      />
    </div>
  );
};
